import React, { Suspense } from 'react';
import { GlobalContext } from '../Utils/contexts.js';
import { getTooltipStyles } from './tooltipStyles.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const lazyWithPreload = (factory) => {
  const Component = React.lazy(factory);
  Component.preload = factory;
  return Component;
};
const ToolTipComponent = lazyWithPreload(async () => {
  var _a;
  const result = await import(
    /* webpackChunkName: "react-portal-tooltip" */
    'react-portal-tooltip'
  );
  return ((_a = result.default) == null ? void 0 : _a.default) ? result.default : result;
});
class Tooltip extends React.Component {
  constructor() {
    super(...arguments);
    this.disabled = false;
    this.mousePosition = { x: 0, y: 0 };
    this.state = {
      tooltipVisible: false
    };
    this.showTooltip = (e) => {
      ToolTipComponent.preload();
      if (!e.target.disabled) {
        this.mousePosition = { x: e.pageX, y: e.pageY };
        this.timeoutId = setTimeout(() => {
          this.setState({ tooltipVisible: true }, () => {
            this.forceUpdate();
            setTimeout(() => this.props.followMouse && this.updateTooltipPosition());
          });
        }, 300);
      }
    };
    this.onMouseMove = (e) => {
      if (this.props.followMouse) {
        this.mousePosition = { x: e.pageX, y: e.pageY };
        this.updateTooltipPosition();
      }
    };
    this.updateTooltipPosition = () => {
      const { x, y } = this.mousePosition;
      const element = document.querySelector(".ToolTipPortal > div");
      if (element) {
        const { offsetWidth: width, offsetHeight: height } = element;
        element.style.left = `${x - width / 2}px`;
        element.style.top = `${y - height - 25}px`;
      }
    };
    this.hideTooltip = () => {
      clearTimeout(this.timeoutId);
      this.setState({ tooltipVisible: false });
    };
    this.wrappChildrenProp = (propName, func) => {
      return {
        [propName]: (e) => {
          var _a, _b;
          func(e);
          (_b = (_a = this.props.children.props)[propName]) == null ? void 0 : _b.call(_a, e);
        }
      };
    };
    this.wrapperProps = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, this.wrappChildrenProp("onMouseEnter", this.showTooltip)), this.wrappChildrenProp("onMouseLeave", this.hideTooltip)), this.wrappChildrenProp("onClick", this.hideTooltip)), this.wrappChildrenProp("onMouseMove", this.onMouseMove));
  }
  componentDidUpdate() {
    this.disabled = window.richContentHideTooltips;
  }
  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }
  render() {
    const {
      children,
      content,
      isError,
      place,
      tooltipOffset,
      followMouse,
      hideArrow,
      forceVisibility
    } = this.props;
    const { tooltipVisible } = this.state;
    const { isMobile } = this.context;
    const style = getTooltipStyles(isError, followMouse, tooltipOffset, place);
    const elementProps = forceVisibility || tooltipVisible ? __spreadProps(__spreadValues({}, this.wrapperProps), { "data-tooltipid": true }) : this.wrapperProps;
    const tooltipArrow = hideArrow ? null : "center";
    return isMobile || this.disabled || !content ? children : /* @__PURE__ */ React.createElement(React.Fragment, null, React.cloneElement(React.Children.only(children), elementProps), forceVisibility || tooltipVisible ? /* @__PURE__ */ React.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React.createElement(
      ToolTipComponent,
      {
        active: forceVisibility || tooltipVisible,
        parent: "[data-tooltipid=true]",
        position: place,
        arrow: tooltipArrow,
        style,
        tooltipTimeout: 10,
        group: "ricos"
      },
      content
    )) : null);
  }
}
Tooltip.defaultProps = {
  isError: false,
  place: "top",
  tooltipOffset: { x: 0, y: 0 }
};
Tooltip.contextType = GlobalContext;

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
